import React from "react";
import styled from "styled-components";

const Container = styled.div`
  height: 50px;
`;
const Wrapper = styled.div`
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Left = styled.div`
  width: 60%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Logo = styled.h1`
  font-weight: bold;
  position: relative;
  top: -3px;
  cursor: pointer;
  text-decoration: underline crimson;
`;

const Menu = styled.ul`
  display: flex;
  list-style: none;

  @media only screen and (max-width: 480px) {
    display: none;
  }
`;

const MenuItem = styled.li`
  margin-right: 35px;
  position: relative;
  right: 185px;
  bottom: 1.5px;
  font-size: 20px;
  font-weight: bold;
  color: gray;
`;

const Button = styled.button`
  border: 2px solid white;
  padding: 10px 15px;
  background-color: crimson;
  color: white;
  font-weight: bold;
  border-radius: 10px;
  cursor: pointer;
`;

const Navbar = () => {
  return (
    <Container>
      <Wrapper>
        <Left>
          <Logo>Portfolio</Logo>
          <Menu>
            <MenuItem>Home</MenuItem>
            <MenuItem>Education</MenuItem>
            <MenuItem>Skills</MenuItem>
            <MenuItem>Achievements</MenuItem>
          </Menu>
        </Left>
        <Button>Contact Me</Button>
      </Wrapper>
    </Container>
  );
};

export default Navbar;
